import { IAgent, IVoice, Presenter } from '@d-id/types';

export enum CAMPAIGN_TABS {
    AVATAR = 'avatar',
    VOICE_SCRIPT = 'voice',
    VIDEO_PAGE = 'video-page',
}

export interface CampaignFormValues {
    id: string;
    title?: string;
    script_fields: string[];
    script: string;
    script_html?: string;
    description?: string;
    logo_src?: string | File;
    cta_enabled: boolean;
    cta_text?: string;
    cta_url?: string;
    cta_background_color?: string;
    voice: IVoice;
    agent: IAgent;
    presenter: Presenter;
    is_stitch: boolean;
    name?: string;
}
export enum PreviewType {
    DESKTOP = 'preview-desktop',
    MOBILE = 'preview-mobile',
}
